export const PFIS = "/api/folders/:param/pfi"
export const PFI = "/api/folders/:param/pfi/:pfi"


export const PFI_DOWNLOAD = "/api/folders/pfi/:pfi/download_reports"
